import React from "react"
import {Box, Typography} from "@mui/material"


export default function idColumn() {
	return {
		name: 'id_batch',
		label: 'Batch ID',
		options: {
			headerAlign: "left",
			filterType: "textField",
			customBodyRowRenderLite: value => <Box sx={{ display: "flex" }}>
				<Typography variant="subtitle1">
					{value}
				</Typography>
			</Box>
		}
	}
}